/**
 * AppShell — main layout wrapper for authenticated pages
 *
 * Provides top bar, scrollable content area, and bottom navigation (client)
 * or sidebar-style navigation (trainer on wider screens).
 */
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import useAuth from '../../auth/useAuth';
import Icon from '../common/Icon';
import BottomNav from './BottomNav';
import TrainerNav from './TrainerNav';
import TopBar from './TopBar';

const AppShell = () => {
  const { isTrainer } = useAuth();

  return (
    <div className="app-shell">
      <TopBar />
      <main className="app-shell__content">
        <div className="app-shell__inner">
          <Suspense fallback={null}>
            <Outlet />
          </Suspense>
          <p className="support-footer">
            <Icon name="LifeBuoy" size={14} /> Need help? <a href="mailto:support@thrivecompanions.com">support@thrivecompanions.com</a>
          </p>
        </div>
      </main>
      {isTrainer ? <TrainerNav /> : <BottomNav />}
    </div>
  );
};

export default AppShell;
